import React, { Component, useEffect } from 'react'; 
import Image from 'next/image';
import "aos/dist/aos.css";
import AOS from 'aos';

const CraftedFinance = (props) =>{

    const OpenRequestDemo = () =>{
        props.requestdemo();
        // handleRequestDemoClick();
    };
    useEffect(() => {
        AOS.init();
      }, []);
    return(
        <section className={props.classes}>
            <div className="overflow-hidden">
                <div className="grid grid-cols-2 sm:grid-cols-1 gap-3">
                    <div className='h-full grid-box shadow-[0_0_10px_rgba(0,0,0,0.1)]' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <Image className='w-20' src={props.iconimg} alt='icon-img' width={100} height={100}/>
                        <div className='w-full'>
                            <h2 className='text-xl text-secondary font-medium my-2'>{props.iconheading}</h2>
                            <p className='text-base text-secondary font-normal'>{props.iconsubheading}</p>
                        </div>
                    </div>
                    <div className='h-full grid-box shadow-[0_0_10px_rgba(0,0,0,0.1)]' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <Image className='w-20' src={props.iconimg1} alt='icon-img' width={100} height={100}/>
                        <div className='w-full'>
                            <h2 className='text-xl text-secondary font-medium my-2'>{props.iconheading1}</h2>
                            <p className='text-base text-secondary font-normal'>{props.iconsubheading1}</p>
                        </div>
                    </div>
                    <div className='h-full grid-box shadow-[0_0_10px_rgba(0,0,0,0.1)]' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <Image className='w-20' src={props.iconimg2} alt='icon-img' width={100} height={100}/>
                        <div className='w-full'>
                            <h2 className='text-xl text-secondary font-medium my-2'>{props.iconheading2}</h2>
                            <p className='text-base text-secondary font-normal'>{props.iconsubheading2}</p>
                        </div>
                    </div>
                    <div className='h-full grid-box shadow-[0_0_10px_rgba(0,0,0,0.1)]' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                        <Image className='w-20' src={props.iconimg3} alt='icon-img' width={100} height={100}/>
                        <div className='w-full'>
                            <h2 className='text-xl text-secondary font-medium my-2'>{props.iconheading3}</h2>
                            <p className='text-base text-secondary font-normal'>{props.iconsubheading3}</p>
                        </div>
                    </div>
                </div>
                <div className='w-full text-center mt-3'>
                    <button onClick={OpenRequestDemo} className='text-white border border-brand text-sm font-bold py-1 px-2 rounded-[10px] bg-brand text-white border border-brand text-sm font-bold py-1 px-2 rounded-[10px] bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]'>{props.cta}</button>
                </div>
            </div>
        </section>
    );
    };
    
    export default CraftedFinance;